import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {benefactorsApi} from '../api';
import {BenefactorModel} from '../model';

/**
 * Облегчённый поиск учётной записи по идентификатору.
 * В отличие от useBenefactorById запрашивает только саму учётную запись, без платежей и рейтинга.
 * Ключ и параметры запроса намеренно совпадают с useBenefactorById: кэш общий, повторного
 * обращения к серверу нет, и учётная запись обновляется по тем же invalidateQueries.
 * @param benefactorId Идентификатор пользователя; пустая строка отключает запрос.
 * @returns Результат запроса учётной записи.
 */
export const useBenefactorLookup = (benefactorId: string): UseQueryResult<BenefactorModel, Error> =>
  useQuery<BenefactorModel, Error>({
    queryKey: ['benefactor', benefactorId],
    queryFn: () => benefactorsApi.getBenefactorById(benefactorId),
    enabled: !!benefactorId,
  });
